import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-link-repository',
  templateUrl: './link-repository.component.html',
  styleUrls: ['./link-repository.component.scss']
})
export class LinkRepositoryComponent {

  @Input() urlRepository:any;
}
